import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { DayOfRaceDate } from '@cds/betting-offer/domain-specific/horse-racing';
import { PrettyUrlsConfig, RacingConfig } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { translationToStr } from '@frontend/sports/common/core/utils/translations';
import { MeetingModel, RacingUrlParam } from '@frontend/sports/racing/feature/models';
import { IntlService } from '@frontend/vanilla/core';
import { Observable, map, of } from 'rxjs';

import { HorseRacingApiService } from '../../../horse-racing-shared/services/horse-racing-api.service';
import { HorseRacingPostApiService } from '../../../horse-racing-shared/services/horse-racing-post-api.service';
import { AbstractRacingService } from '../../../horse-racing-shared/services/racing-api.service';

export class RacingAllResolver {
    constructor(
        private apiService: AbstractRacingService,
        private urlConfig: PrettyUrlsConfig,
        private intlService: IntlService,
        private racingConfig: RacingConfig,
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<MeetingModel | undefined> {
        const meetingId = +route.params.meetingId;
        const day = this.getDayOfRace(route.params.filter);
        if (meetingId && day) {
            return this.apiService.getMeeting(meetingId, day).pipe(
                map((fixtures) => {
                    if (!fixtures.length) {
                        return undefined;
                    }
                    const fixture = fixtures[0];
                    if (fixture.sport.id === SportConstant.Horses) {
                        fixtures.forEach((currentFixture) => {
                            if (day === DayOfRaceDate.Tomorrow) {
                                currentFixture.addons.bestOddsGuarantee = false;
                            } else if (day === DayOfRaceDate.Today) {
                                const startTime = this.intlService.formatDate(currentFixture.startDate, 'HH:mm');
                                if (startTime <= this.racingConfig.bogTodayThresholdTime) {
                                    currentFixture.addons.bestOddsGuarantee = false;
                                }
                            }
                        });
                    }

                    return {
                        meeting: {
                            id: fixture.meeting.id,
                            name: translationToStr(fixture.meeting.name),
                        },
                        fixtures,
                        day,
                    };
                }),
            );
        }

        return of(undefined);
    }

    private getDayOfRace(routeParam: string): DayOfRaceDate {
        const param = (routeParam && routeParam.toLowerCase()) || '';

        return param === this.urlConfig.translations.today.toLowerCase() || param === RacingUrlParam.Today
            ? DayOfRaceDate.Today
            : DayOfRaceDate.Tomorrow;
    }
}

@Injectable()
export class HorsesMeetingAllResolver extends RacingAllResolver {
    constructor(horseRacingApi: HorseRacingApiService, urlConfig: PrettyUrlsConfig, intlService: IntlService, racingConfig: RacingConfig) {
        super(horseRacingApi, urlConfig, intlService, racingConfig);
    }
}

@Injectable()
export class HorsesMeetingAllRacingPostResolver extends RacingAllResolver {
    constructor(horseRacingApi: HorseRacingPostApiService, urlConfig: PrettyUrlsConfig, intlService: IntlService, racingConfig: RacingConfig) {
        super(horseRacingApi, urlConfig, intlService, racingConfig);
    }
}
